import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractCustomerComponent } from '@df/account/v2/abstract-customer.component';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AccountBackComponent } from '../../back/account-back.component';
import { AccountSavedCardItemComponent } from '../item/account-saved-card-item.component';
@Component({
    selector: 'account-saved-card-book',
    templateUrl: './account-saved-card-book.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SizeClassDirective, TranslationModule, AccountBackComponent, CommonModule, AccountSavedCardItemComponent, GridModule]
})
export class AccountSavedCardBookComponent extends AbstractCustomerComponent implements OnInit {
    /**
     * List of cards
     */
    cards?: CreditCard[];
    protected override onCustomerDataChange(): void {
        const cards = this.customer.model.cards || [];
        this.cards = [...cards.filter(i => i.data.is_default), ...cards.filter(i => !i.data.is_default)];
        super.onCustomerDataChange();
    }
}
